module.exports = __webpack_public_path__ + "files/4863c38c8354a71eb6d3422a0d68749f.svg";